import apis from '@/apis';
import { RESET_DATA_PANEL } from './constants';
export const FETCH_USER_PORTRAIT_SUCCESS = 'FETCH_USER_PORTRAIT_SUCCESS';
export const FETCH_USER_PORTRAIT_ERROR = 'FETCH_USER_PORTRAIT_ERROR';
export const FETCH_USER_PORTRAIT_UPDATE = 'FETCH_USER_PORTRAIT_UPDATE';

export const fetchUserPortrait = (data) =>
  function (dispatch, getState) {
    dispatch({
      type: FETCH_USER_PORTRAIT_UPDATE,
    });
    return apis
      .queryUserPortrait(data)
      .then((res) => {
        if (res && res.ret === '0') {
          let data = res.data;

          // 如果没有activityRooms那么应该也不会有其他数据
          if (!data || !data.activityRooms) data = { activityRooms: [] };

          dispatch({
            type: FETCH_USER_PORTRAIT_SUCCESS,
            payload: data,
          });
        } else {
          dispatch({
            type: FETCH_USER_PORTRAIT_ERROR,
          });
        }
        return res;
      })
      .catch(() => {
        dispatch({
          type: FETCH_USER_PORTRAIT_ERROR,
        });

        return {};
      });
  };

const initialState = {
  loadedInfo: false,
  histogramList: [],
  portraitList: [],
  activityRooms: [],
};

export default function userPortrait(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_USER_PORTRAIT_SUCCESS:
      return Object.assign({}, state, payload, {
        loadedInfo: true,
      });
    case FETCH_USER_PORTRAIT_ERROR:
      return Object.assign({}, state, {
        loadedInfo: true,
      });
    case FETCH_USER_PORTRAIT_UPDATE:
      return Object.assign({}, state, {
        histogramList: [],
        portraitList: [],
        loadedInfo: true,
      });
    case RESET_DATA_PANEL:
      return initialState;
    default:
      return state;
  }
}
